import TextInputSearch from "../../../../../../common/components/atom/TextInputSearch/TextInputSearch";
import { usePlanBT } from "../../../../hooks";


export default function PlanBTSearchPresenter() {
    const { allPlanBTQuery:{setPlanBtListIsLoading, setQuerySearch, getQuerySearch, setPage}} = usePlanBT()
    const inti =getQuerySearch&& getQuerySearch()
    const callbackOnchange = () => {
        setPage(1)
      }
  return (
    <TextInputSearch placeholder={'Rechercher'}  setIsLoading={setPlanBtListIsLoading} sendQuery={setQuerySearch} valueInit={inti} onChangeCallback={callbackOnchange}/>
  )
}
